import type { DomainSchema, PdfCardDef } from '../types';
import { dateRange, esc, metaJoin } from '../pdf-helpers';

export const POSITIONS = {
  priority: true,
  cardTitle: '{title} at {companyName}',
  fields: {
    title: { type: 'text', label: 'Job Title' },
    companyName: { type: 'text', label: 'Company' },
    location: { type: 'text' },
    employmentType: { type: 'text', label: 'Employment Type' },
    startDate: { type: 'date', label: 'Start Date' },
    endDate: { type: 'date', label: 'End Date' },
    isCurrent: { type: 'checkbox', label: 'Currently working here' },
    description: { type: 'textarea' },
  },
  layout: [
    [{ field: 'title' }, { field: 'companyName' }],
    [{ field: 'location' }, { field: 'employmentType' }],
    [
      { field: 'startDate', width: 50 },
      { field: 'endDate', width: 50 },
    ],
    [{ field: 'isCurrent' }],
    [{ field: 'description' }],
  ],
} satisfies DomainSchema;

export const PositionsPdfCard: PdfCardDef = {
  styles: `
    .pos-item { padding: 0.9rem 0; border-bottom: 1px solid var(--line); }
    .pos-item:first-child { padding-top: 0; }
    .pos-item:last-child { border-bottom: none; padding-bottom: 0; }
    .pos-role { font-size: 13.5px; font-weight: 700; display: flex; align-items: center; gap: 7px; flex-wrap: wrap; }
    .pos-company { font-size: 12px; color: var(--blue-gray); font-weight: 700; margin-top: 2px; }
    .pos-meta { font-size: 11px; color: var(--muted); margin-top: 3px; display: flex; gap: 10px; flex-wrap: wrap; }
  `,
  render(records) {
    return records
      .map(r => {
        const meta = metaJoin([
          r['location'] ? esc(r['location']) : null,
          dateRange(r['startDate'], r['endDate'], Boolean(r['isCurrent'])) || null,
          r['employmentType'] ? esc(r['employmentType']) : null,
        ]);
        return `
          <div class="pos-item">
            <div class="pos-role">${esc(r['title']) || '\u2014'}${
              r['isCurrent'] ? ' <span class="bp-current">Current</span>' : ''
            }</div>
            <div class="pos-company">${esc(r['companyName'])}</div>
            ${meta ? `<div class="pos-meta">${meta}</div>` : ''}
            ${r['description'] ? `<div class="bp-note">${esc(r['description'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
